import React from "react";
import styles from "./CategoryCard.module.css";

interface CategoryCardProps {
    icon: string;
    title: string;
    serviceCount: number;
}

function CategoryCard({ icon, title, serviceCount }: CategoryCardProps) {
    return (
        <>
            <div className={styles.card}>
                <div className={styles.iconWrap}>
                    <img src={icon} alt={title} />
                </div>
                <div className={styles.info}>
                    <h3>{title}</h3>
                    <p>{serviceCount} services</p>
                </div>
            </div>
        </>
    );
}

export default CategoryCard